/* Honor Shopify's regional consent decision before loading Clarity. */
(() => {
  let loaded = false;
  function syncConsent() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    const analytics = privacy.analyticsProcessingAllowed();
    const ads = privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    if (!analytics && !loaded) return;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    window.clarity('consentv2', {
      analytics_Storage: analytics ? 'granted' : 'denied',
      ad_Storage: ads ? 'granted' : 'denied'
    });
    if (!loaded && analytics) {
      loaded = true;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/x8o9j3l0bp';
      document.head.appendChild(script);
    }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) syncConsent();
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cookie-preferences]');
    const dialog = document.getElementById('store-cookie-preferences');
    if (!link || !dialog) return;
    event.preventDefault();
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    dialog.querySelector('[data-consent-error]').hidden = !!privacy;
    dialog.querySelector('[name="preferences"]').checked = !!privacy && privacy.preferencesProcessingAllowed();
    dialog.querySelector('[name="analytics"]').checked = !!privacy && privacy.analyticsProcessingAllowed();
    dialog.querySelector('[name="marketing"]').checked = !!privacy && privacy.marketingAllowed();
    dialog.showModal();
  });
  const dialog = document.getElementById('store-cookie-preferences');
  if (dialog) {
    dialog.querySelector('[data-consent-close]').addEventListener('click', () => dialog.close());
    function save(reject) {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) { dialog.querySelector('[data-consent-error]').hidden = false; return; }
      const consent = {};
      ['preferences', 'analytics', 'marketing'].forEach(key => {
        consent[key] = !reject && dialog.querySelector(`[name="${key}"]`).checked;
      });
      privacy.setTrackingConsent(consent, () => { syncConsent(); dialog.close(); });
    }
    dialog.querySelector('[data-consent-reject]').addEventListener('click', () => save(true));
    dialog.querySelector('[data-consent-save]').addEventListener('click', () => save(false));
  }
})();
